import { Util, Request } from "@xt/xtbase";

const { getOrigin } = Util;
const { XtAxios4 } = Request;

const URL = getOrigin("www") + "/sapi/v4/payment/";

export function getFiats(config) {
  return XtAxios4.get(URL + "public/fiats", config);
}

export function getCryptos(config) {
  return XtAxios4.get(URL + "public/cryptos", config);
}

export function getMethods(config) {
  return XtAxios4.get(URL + "public/methods", config);
}

export function getChannels(config) {
  return XtAxios4.get(URL + "public/channels", config);
}

export function getBestPlan(config) {
  return XtAxios4.get(URL + "best-plan", config);
}

export function getQuote(config) {
  return XtAxios4.get(URL + "quote", config);
}

export function postOrderBuy(data, config) {
  return XtAxios4.post(URL + "order/buy", data, config);
}

export function postOrderSell(data, config) {
  return XtAxios4.post(URL + "order/sell", data, config);
}

export function getOrders(config) {
  return XtAxios4.get(URL + "orders", config);
}

export function getLimit(config) {
  return XtAxios4.get(URL + "public/limit", config);
}

export function getTradeLimit(config) {
  return XtAxios4.get(URL + "trade/limit", config);
}
